import { IUser } from '../@services/users.service';
import {
  IOneFriend,
  IUserAllergies,
  IUserSubscribeListItem,
  UserAllergiesType,
} from '../@types/user.types';
import {
  IBaseUserDTOJoined,
  IOneFriendDTO,
  IUserAllergiesDTO,
  IUserAllergyUpdateDTO,
  IUserSubscribeListItemDTO,
} from '../@types/user.types.dto';

export const mapOneFriendToFront = (backData: IOneFriendDTO): IOneFriend => {
  return {
    id: +backData.user.id,
    name: backData.user.name,
    surname: backData.user.surname,
    photo: backData.user.photo_100,
    isGirl: backData.user.sex !== '1',
    statistic: backData.statistic
      ? {
          hikingCount: +backData.statistic.count,
          hikingLastDate: new Date(backData.statistic.last_finish_date),
          hikingFirstDate: new Date(backData.statistic.first_start_date),
          hikingIds: backData.statistic.hikings.split(',').map(Number),
        }
      : null,
  };
};

const mapUserAllergyTypeToFront = (backData: IUserAllergiesDTO['type']): UserAllergiesType => {
  switch (backData) {
    case '1':
      return UserAllergiesType.Medicament;
    case '2':
      return UserAllergiesType.Product;
    default:
      return UserAllergiesType.Other;
  }
};

export const mapUserAllergyToFront = (backData: IUserAllergiesDTO): IUserAllergies => {
  return {
    id: +backData.id,
    type: mapUserAllergyTypeToFront(backData.type),
    name: backData.name,
    comment: backData.comment,
    created_at: new Date(backData.created_at),
    updated_at: backData.updated_at ? new Date(backData.updated_at) : null,
    product: !backData.id_product
      ? null
      : {
          id: +backData.id_product,
          name: backData.product_name ?? '',
        },
    medicament: !backData.id_medicament
      ? null
      : {
          id: +backData.id_medicament,
          name: backData.medicament_name ?? '',
        },
  };
};

export const mapUserAllergyToBack = (frontData: IUserAllergies): IUserAllergyUpdateDTO => {
  return {
    id: frontData.id,
    type: frontData.type,
    name: frontData.name,
    comment: frontData.comment,
    id_product: frontData.product?.id ? frontData.product.id : null,
    id_medicament: frontData.medicament?.id ? frontData.medicament.id : null,
  };
};

export const mapUserSubscribeListItem = (
  backData: IUserSubscribeListItemDTO,
): IUserSubscribeListItem => {
  return {
    id: +backData.id,
    email: backData.email,
    confirm_date: backData.confirm_date ? new Date(backData.confirm_date) : null,
    is_confirmed: backData.is_confirmed === '1',
    is_active: backData.is_active === '1',
    regions: backData.regions.map((x) => {
      const { id, name } = x;
      return { id: +id, name };
    }),
    types: backData.types.map((x) => {
      const { id, name } = x;
      return { id: +id, name };
    }),
  };
};

export const mapBaseUserJoinedToFront = (backData: IBaseUserDTOJoined): IUser => {
  return {
    id: +backData.user_id,
    name: backData.user_name,
    surname: backData.user_surname,
    photo: backData.user_photo,
  };
};
